import type { Moment } from 'moment'
import React, { useCallback } from 'react'

import AdditionalDetails from './AdditionalDetails'
import CreateTripStart from './CreateTripStart'

import noop from 'lib/function/noop'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import type { FullTrip } from 'tripPlanner/types/common'

interface Props {
  startDate?: Moment
  endDate?: Moment
  onCreateTrip?: (trip: FullTrip) => void
}

/**
 * This is one of two components that are almost the same, except this one is for use with the Trip Planner modal context.
 * For use with the main CP modal context, use CreateTripMC.tsx
 */
function CreateTripTP({
  startDate,
  endDate,
  onCreateTrip: onFinish = noop,
}: Props) {
  const openModal = useOpenModal()
  const { closeModal } = useModalCallbacks()

  const onAdditionalDetailsClose = useCallback(
    (trip: FullTrip) => {
      closeModal()
      onFinish(trip)
    },
    [closeModal, onFinish],
  )

  const onCreateTrip = useCallback(
    (trip: FullTrip) => {
      openModal(
        AdditionalDetails,
        {
          trip,
          onClose: onAdditionalDetailsClose,
          isInBookmarkingFlow: false,
        },
        {
          height: 'auto',
          size: 'L',
        },
      )
    },
    [onAdditionalDetailsClose, openModal],
  )

  return (
    <CreateTripStart
      startDate={startDate}
      endDate={endDate}
      onCancel={closeModal}
      onCreateTrip={onCreateTrip}
    />
  )
}

export default CreateTripTP
